/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2022] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

 import _ from 'lodash';
 import Backbone from 'backbone';
 
 import ErrorView from '@/views/ErrorView/ErrorView';
 import Scaffold from '@/Scaffold';
 import { userHasRole } from '@/util/RoleUtils';
 import GetAllOrderFormTypes from '@/services/GetAllOrderFormTypes';

 import EditOrderFormView from '../views/EditOrderFormView';

 export default async function loadEditOrderFormsView() {
   if (!userHasRole('Admin')) {
     showErrorView();
     return;
   }
 
   try {
     const [orderFormTypes] = await Promise.all([
        GetAllOrderFormTypes()
     ]);

     _.each(orderFormTypes, (x) => {
       x.name = x.descriptiveFormName;
     });

     return new EditOrderFormView({
       model: new Backbone.Model({
        orderFormTypes
       })
     });
   } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Edit Order Form page.'
        })
      })
    );
   }
 }
 
 function showErrorView(err) {
   Scaffold.getRegion('content').show(
     new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Edit Order Form page.'
      })
     })
   );
 }
 